import styled from 'styled-components';
import options from '../animatedVisualizations/options';

import playIcon from './assets/play.svg';

export const PhotoBoxWrapper = styled.div`
    display: flex;
    flex-direction: column;
    flex: 0 0 33.33%;
    visibility: hidden;
    height: 320px;
    align-items: center;
    z-index: ${props => (props.fullscreen ? 100 : (options.maxSelectedCount - props.idx))};
`;

export const ContentWrapper = styled.div`
    padding: 10px;
    background-color: white;
    box-shadow: 0px 0px 15.48px 2.52px rgba(42, 40, 40);
    width: fit-content;
    position: relative;
`;

export const Img = styled.img`
    width: auto;
    max-width: 100%;
    margin: 0 auto;
    height: 300px;
    display: block;
`;

export const Video = styled.video`
    width: auto;
    max-width: 100%;
    margin: 0 auto;
    height: 300px;
    display: block;
`;

export const PlayIcon = styled.figure`
    background: url(${playIcon}) no-repeat center;
    width: 100%;
    height: 100%;
    margin: 0;
    position: absolute;
    top: 0;
    left: 0;
`;

export const UserWrapper = styled.div`
    position: absolute;
    right: -70px;
    bottom: 20px;
    transform: skew(-2deg, 2deg);
`;

export const WrappedUser = styled.div`
    font-size: 46px;
    color: #2D2D2D;
    text-align: center;
    font-weight: bold;
    background-color: white;
    padding: 10px;
    opacity: 0;
    visibility: hidden;
    box-shadow: 0px 0px 15.48px 2.52px rgba(42, 40, 40);
    max-width: 155px;
`;

export const User = styled.div`
    font-size: 46px;
    color: #2D2D2D;
    text-align: center;
    font-weight: bold;
    position: absolute;
    right: -20px;
    bottom: 20px;
    transform: skew(-2deg, 2deg);
    background-color: white;
    padding: 10px;
    opacity: 0;
    visibility: hidden;
    box-shadow: 0px 0px 15.48px 2.52px rgba(42, 40, 40);
    max-width: 155px;
`;



// WEBPACK FOOTER //
// ./src/ui/interaction/children/ugcvisualization/components.js